// ============================================================================
// config-year-options — options du selecteur d'annee unique (AD-D2 D2)
// ============================================================================
// [annees yearConfigs] U [annees teamTargets] U {courante, courante+1},
// dedupliquees, triees decroissant. Bornes serveur 2000..2100 = verite.

export function buildConfigYearOptions(
  yearConfigs: readonly { year: number }[],
  teamTargets: readonly { year: number }[],
  currentYear: number,
): number[] {
  const years = new Set<number>();
  for (const row of yearConfigs) years.add(row.year);
  for (const row of teamTargets) years.add(row.year);
  years.add(currentYear);
  years.add(currentYear + 1);
  return [...years]
    .filter((y) => Number.isInteger(y) && y >= 2000 && y <= 2100)
    .sort((a, b) => b - a);
}
